(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oliw87-shop-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('oliw-commerce');
  if (!root || root.dataset.shopReady) return;
  root.dataset.shopReady = 'true';
  let busy = false;
  let previousFocus = null;
  const cartDialog = () => root.querySelector('#OliwCart');
  const status = text => { root.querySelector('[data-shop-status]').textContent = text; };
  const initialize = () => {
    root.querySelectorAll('[data-cart-step]').forEach(button => { button.hidden = false; });
    root.querySelectorAll('[data-update-cart]').forEach(button => { button.hidden = true; });
    const content = cartDialog()?.querySelector('[data-cart-content]');
    if (content) root.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = content.dataset.count; });
  };
  const ids = () => [cartDialog()?.dataset.cartSection, root.querySelector('[data-cart-page-section]')?.dataset.cartPageSection].filter(Boolean);
  const contextURL = () => location.pathname + location.search;
  const request = async (url, options = {}) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try { return await fetch(url, { ...options, credentials: 'same-origin', signal: controller.signal }); }
    finally { clearTimeout(timer); }
  };
  const applySections = sections => {
    if (!sections) return false;
    const replacements = [];
    for (const id of ids()) {
      const html = sections[id];
      if (typeof html !== 'string') return false;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('[data-cart-content]');
      const host = document.getElementById('shopify-section-' + id);
      const current = host?.querySelector('[data-cart-content]');
      if (!fresh || !current) return false;
      replacements.push([current, fresh]);
    }
    for (const [current, fresh] of replacements) current.replaceWith(fresh);
    initialize();
    return true;
  };
  const refresh = async () => {
    const url = new URL(location.href);
    url.searchParams.set('sections', ids().join(','));
    const response = await request(url.toString(), { headers: { Accept: 'application/json' } });
    if (!response.ok || !applySections(await response.json())) throw new Error(root.dataset.cartError);
  };
  const lock = value => {
    busy = value;
    root.setAttribute('aria-busy', String(value));
    root.querySelectorAll('button,input,select').forEach(control => {
      if (value) { control.dataset.shopWasDisabled = String(control.disabled); control.disabled = true; }
      else if (control.dataset.shopWasDisabled !== undefined) { control.disabled = control.dataset.shopWasDisabled === 'true'; delete control.dataset.shopWasDisabled; }
    });
  };
  const showError = (message, form) => {
    const error = form?.isConnected ? form.querySelector('[data-form-error]') : null;
    const target = error || root.querySelector('dialog[open] [data-cart-error]') || root.querySelector('[data-cart-page-section] [data-cart-error]');
    const text = typeof message === 'string' ? message : root.dataset.cartError;
    if (target) { target.textContent = text; target.scrollIntoView({ block: 'nearest' }); }
    status(text);
  };
  const openDialog = dialog => {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    previousFocus = document.activeElement;
    root.querySelectorAll('dialog[open]').forEach(open => open.close());
    dialog.showModal();
    dialog.querySelector('[data-close-dialog]')?.focus({ preventScroll: true });
    return true;
  };
  const closeDialog = dialog => {
    dialog?.close();
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  };
  const mutate = async (url, body, form, openAfter, focusKey) => {
    if (busy) return;
    const sectionIds = ids();
    if (!sectionIds.length) { location.assign(root.dataset.cartUrl); return; }
    let payload;
    const headers = { Accept: 'application/json' };
    if (body instanceof FormData) {
      body.set('sections', sectionIds.join(','));
      body.set('sections_url', contextURL());
      payload = body;
    } else {
      headers['Content-Type'] = 'application/json';
      payload = JSON.stringify({ ...body, sections: sectionIds, sections_url: contextURL() });
    }
    root.querySelectorAll('[data-form-error],[data-cart-error]').forEach(node => { node.textContent = ''; });
    const trigger = document.activeElement;
    lock(true);
    try {
      const response = await request(url, { method: 'POST', headers, body: payload });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : result.message || root.dataset.cartError);
      if (!applySections(result.sections)) {
        try { await refresh(); }
        catch { location.assign(root.dataset.cartUrl); return; }
      }
      if (openAfter) {
        if (!openDialog(cartDialog())) location.assign(root.dataset.cartUrl);
        previousFocus = trigger;
      } else if (focusKey) {
        const scope = cartDialog()?.open ? cartDialog() : root.querySelector('[data-cart-page-section]');
        const row = [...(scope?.querySelectorAll('[data-line-key]') || [])].find(line => line.dataset.lineKey === focusKey);
        (row?.querySelector('[data-cart-quantity]') || scope?.querySelector('[data-close-dialog]'))?.focus({ preventScroll: true });
      }
      status(openAfter ? root.dataset.added : root.dataset.updated);
    } catch (error) {
      try { await refresh(); } catch {}
      showError(error.name === 'AbortError' ? root.dataset.cartError : error.message, form);
    } finally {
      lock(false);
      if (openAfter && cartDialog()?.open) cartDialog().querySelector('[data-close-dialog]')?.focus({ preventScroll: true });
    }
  };
  const changeQuantity = (row, quantity) => {
    if (!row || busy) return;
    const input = row.querySelector('[data-cart-quantity]');
    if (!Number.isInteger(quantity) || quantity < 0) { showError(root.dataset.cartError); return; }
    mutate(root.dataset.changeUrl, { id: row.dataset.lineKey, quantity }, null, false, row.dataset.lineKey);
  };
  root.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('[data-shop-add]')) {
      if (typeof cartDialog()?.showModal !== 'function') return;
      event.preventDefault();
      if (!busy) mutate(root.dataset.addUrl, new FormData(form), form, true);
    } else if (form.matches('[data-shop-cart-form]') && busy) event.preventDefault();
  });
  root.addEventListener('click', async event => {
    const target = event.target.closest('a,button');
    if (!target) return;
    if (target.matches('[data-open-cart]')) {
      if (typeof cartDialog()?.showModal !== 'function') return;
      event.preventDefault();
      if (busy) return;
      openDialog(cartDialog()); lock(true);
      try { await refresh(); } catch { showError(root.dataset.cartError); } finally { lock(false); }
    } else if (target.matches('[data-close-dialog]')) {
      event.preventDefault(); closeDialog(target.closest('dialog'));
    } else if (target.matches('[data-continue-shopping]') && target.closest('dialog')) {
      event.preventDefault(); closeDialog(target.closest('dialog'));
    } else if (target.matches('[data-cart-step],[data-cart-remove]')) {
      event.preventDefault();
      if (busy) return;
      const row = target.closest('[data-line-key]');
      const input = row.querySelector('[data-cart-quantity]');
      let next = 0;
      if (target.matches('[data-cart-step]')) {
        next = Number(input.value) + Number(target.dataset.cartStep) * (Number(input.step) || 1);
        if (next > 0 && next < Number(input.dataset.min)) next = target.dataset.cartStep === '-1' ? 0 : Number(input.dataset.min);
        if (input.max && next > Number(input.max)) return;
      }
      changeQuantity(row, Math.max(0, next));
    } else if (target.matches('[data-media-select]')) {
      const product = target.closest('[data-shop-product]');
      product.querySelectorAll('[data-media-panel]').forEach(panel => {
        const active = panel.dataset.mediaPanel === target.dataset.mediaSelect;
        panel.classList.toggle('is-active', active);
        if (!active) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      product.querySelectorAll('[data-media-select]').forEach(button => { button.setAttribute('aria-pressed', String(button === target)); });
    } else if (target.matches('[data-zoom-image]')) {
      const dialog = target.closest('[data-shop-product]').querySelector('[data-zoom-dialog]');
      if (typeof dialog?.showModal !== 'function') return;
      event.preventDefault();
      const img = dialog.querySelector('img');
      img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = target.dataset.zoomImage; img.alt = target.dataset.alt;
      openDialog(dialog);
    }
  });
  root.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('[data-cart-quantity]')) changeQuantity(input.closest('[data-line-key]'), Number(input.value));
    if (input.matches('[data-shop-sort],[data-shop-variant]')) {
      const url = new URL(location.href);
      url.searchParams.delete('section_id'); url.searchParams.delete('sections');
      if (input.matches('[data-shop-sort]')) { url.searchParams.set('sort_by', input.value); url.searchParams.delete('page'); }
      else url.searchParams.set('variant', input.value);
      location.assign(url.toString());
    }
  });
  root.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(dialog);
    });
  });
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', event => { if (event.persisted && !busy) refresh().catch(() => {}); });
  initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
